export default __webpack_public_path__ + "static/media/Flesh Fillet.624f53cb.png";